import * as z from "zod/v4";
import { discountConfiguration, redoDiscountSchema } from "./discount-schemas";

export const createDiscount = {
  name: "createDiscount" as const,
  input: z.object({ discountConfiguration }),
  output: redoDiscountSchema,
};
